<template>
    <div class="Policies">
        <template v-if="policies && policies.length">
           <div class="Policies--wrapper">
               <div class="Policies--wrapper-content"
                    v-for="(policy, index) of policies"
                    :key="index"
               >
                   <h3 class="Policies--wrapper-content-title">{{policy.title}}</h3>
                   <div class="Policies--wrapper-content-data"
                        v-html="policy.content"
                   />
               </div>
           </div>
        </template>
        <template v-else>
            <div class="not-found">
                <img src="../../../../assets/img/empty-policies.png"
                     alt="NoPolicies"
                >
                <h3>Sorry, no policies</h3>
            </div>
        </template>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'Policies',

        computed: {
            ...mapGetters(['policies']),
        },

        methods: {
            ...mapActions(['getPolicies']),
        },

        created() {
            this.getPolicies()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../assets/styles/variables/colors';

    .Policies {
        &--wrapper {
            margin-top: 39px;
            margin-bottom: 44px;
            padding: 60px 92px;
            border-radius: 4px;
            box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.15);
            background-color: $White;

            @media screen and (max-width: 600px) {
                padding: 25px 20px;
            }

            &-content {
                color: $Dark;
                margin-bottom: 40px;

                &-title {
                    font-size: 24px;
                    line-height: 0.88;
                }

                &-data {
                    margin-top: 25px;
                    font-size: 14px;
                    line-height: 1.43;
                    word-break: break-word;
                    white-space: initial;
                    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {  //for IE
                        word-break: break-all;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/Activities/Policies.vue